
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

export default function ViewTransactionsRanges(periodInfo) {

    dayjs.extend(quarterOfYear);

    const currentDate = dayjs();

    const fiscalStart = periodInfo?.fiscalStartDate
        ? dayjs(periodInfo.fiscalStartDate)
        : currentDate.startOf('year');

    const fiscalEnd = periodInfo?.fiscalEndDate
        ? dayjs(periodInfo.fiscalEndDate)
        : currentDate.endOf('year');


    const monthsDiff = currentDate.diff(fiscalStart, 'month');
    const quarterIndex = Math.floor(monthsDiff / 3);

    const quarterStart = fiscalStart.add(quarterIndex * 3, 'month');

    const quarterEnd = quarterStart
        .add(3, 'month')
        .subtract(1, 'day')
        .endOf('day');

    const dateOptions = [
        {
            date: "-Select Period-",
            actualValue: {
                start: null,
                end: null
            }
        },
        {
            date: "Range",
            actualValue: { start: null, end: null }
        },

        {
            date: "Today",
            actualValue: {
                start: currentDate.startOf('day'),
                end: currentDate.endOf('day')
            }
        },
        {
            date: "Yesterday",
            actualValue: {
                start: currentDate.subtract(1, 'day').startOf('day'),
                end: currentDate.subtract(1, 'day').endOf('day')
            }
        },
        {
            date: "Past 30 Days",
            actualValue: {
                start: currentDate.subtract(29, 'day'),
                end: currentDate
            }
        },
        {
            date: "This Week",
            actualValue: {
                start: currentDate.startOf('week').toDate(),
                end: currentDate.endOf('week').toDate()
            }
        },
        {
            date: "This Week – to – Date",
            actualValue: {
                start: currentDate.startOf('week').toDate(),
                end: currentDate.toDate()
            }
        },
        {
            date: "Last Week",
            actualValue: {
                start: currentDate.subtract(1, 'week').startOf('week').toDate(),
                end: currentDate.subtract(1, 'week').endOf('week').toDate()
            }
        },
        {
            date: "Last Week–to–Date",
            actualValue: {
                start: currentDate.subtract(1, 'week').startOf('week').toDate(),
                end: currentDate
                    .subtract(1, 'week')
                    .endOf('day')
                    .toDate()
            }
        },
        {
            date: "This Month",
            actualValue: {
                start: currentDate.startOf('month').toDate(),
                end: currentDate.endOf('month').toDate()
            }
        },
        {
            date: "This Month – to – Date",
            actualValue: {
                start: currentDate.startOf('month').toDate(),
                end: currentDate.toDate()
            }
        },
        {
            date: "Last Month",
            actualValue: {
                start: currentDate.subtract(1, 'month').startOf('month').toDate(),
                end: currentDate.subtract(1, 'month').endOf('month').toDate()
            }
        },
        {
            date: "Last Month – to – Date",
            actualValue: {
                start: currentDate.subtract(1, 'month').startOf('month').toDate(),
                end: currentDate
                    .subtract(1, 'month')
                    .date(currentDate.date())
                    .endOf('day')
                    .toDate()
            }
        },
        {
            date: "This Quarter",
            actualValue: {
                start: quarterStart.toDate(),
                end: quarterEnd.toDate()
            }
        },
        {
            date: "This Quarter – to – Date",
            actualValue: {
                start: quarterStart.toDate(),
                end: currentDate.toDate()
            }
        },
        {
            date: "Last Quarter",
            actualValue: {
                start: quarterStart
                    .subtract(3, 'month')
                    .toDate(),

                end: quarterStart
                    .subtract(1, 'day')
                    .endOf('day')
                    .toDate()
            }
        },
        {
            date: "Last Quarter – to – Date",
            actualValue: {
                start: quarterStart
                    .subtract(3, 'month')
                    .toDate(),

                // end: quarterStart
                //     .subtract(3, 'month')
                //     .add(
                //         currentDate.diff(quarterStart, 'day'),
                //         'day'
                //     )
                //     .endOf('day')
                //     .toDate()
                end: currentDate
                    .subtract(3, 'month')
                    .endOf('day')
                    .toDate()
            }
        },
        {
            date: "This Year",
            // actualValue: {
            //     start: baseDate.startOf('year').toDate(),
            //     end: baseDate.endOf('year').toDate()
            // }
            actualValue: {
                start: fiscalStart,
                end: fiscalEnd
            }
        },
        {
            date: "This Year – to – Date",
            // actualValue: {
            //     start: baseDate.startOf('year').toDate(),
            //     end: baseDate.toDate()
            // }
            actualValue: {
                start: fiscalStart,
                end: currentDate
            }
        },
        {
            date: "Last Year",
            // actualValue: {
            //     start: baseDate.subtract(1, 'year').startOf('year').toDate(),
            //     end: baseDate.subtract(1, 'year').endOf('year').toDate()
            // }
            actualValue: {
                start: fiscalStart.subtract(1, 'year'),
                end: fiscalEnd.subtract(1, 'year')
            }
        },
        {
            date: "Last Year – to – Date",
            // actualValue: {
            //     start: baseDate.subtract(1, 'year').startOf('year').toDate(),
            //     // end: baseDate.subtract(1, 'year').month(baseDate.month()).date(baseDate.date()).endOf('day').toDate()
            //     end: baseDate
            //         .subtract(1, 'year')
            //         .endOf('day')
            //         .toDate()
            // }
            actualValue: {
                start: fiscalStart.subtract(1, 'year'),
                end: currentDate.subtract(1, 'year')
            }
        },

    ];


    return dateOptions;

}
